<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-3">
        <div class="card">
          <div class="card-body card-body-child">
            <div class="header bg-red header-child">
                <p>{{$t('CHILDDETAILS')}}</p>
                <div class="buttons">
                  <button type="button" class="btn button-edit mr-lg"  @click="showModal(child)">{{$t('EDIT')}}</button>
                  <button type="button" class="btn button-add"  @click="showResultAndOpinion(child)">{{$t('RESULTANDOPINION')}}</button>
                </div>
            </div>
            <div class="body body-child">
               <h2>{{child.name}} {{child.surname}}</h2>
                <p><b>{{$t('BIRTHDATE')}}:</b> {{moment(child.birthDate).format('DD.MM.YYYY')}}</p>
                <p><b>{{$t('PHONENUMBER')}}:</b> {{child.phoneNumber}}</p>
                <p><b>{{$t('EMAIL')}}:</b> {{child.email}}</p>
                <p>
                  <b>{{$t('CHILDRENNOTUSERS')}}:</b>
                  <template v-if="child.children" v-for="item in child.children">
                    <a @click="openChildData(item)"> {{item.name}} {{item.surname}} {{ (child.children.length > 1) ? ', ' : '' }}</a>
                  </template>
                </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="card">
          <div class="card-body">
            <div class="body body-child-note">
                <p><b>{{$t('NOTE')}}:</b> {{child.note}}</p>
            </div>
            <div class="text-right">
                <button type="button" class="btn button-edit"  @click="editData('note', child)">{{$t('EDIT')}}</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="card">
          <div class="card-body">
            <b-tabs>
              <b-tab :title="$t('ANAMNESTICFORM')">
                <div class="d-block" v-html="child.anamnestic" style="max-height: 10em; overflow: auto;"></div>
                <div class="text-right">
                  <b-btn class="mt-3 btn button-edit" @click="editData('anamnestic', child)">{{$t('EDIT')}}</b-btn>
                </div>
              </b-tab>
              <b-tab :title="$t('COMMUNICATIONFORM')">
                <div class="d-block" v-html="child.communication" style="max-height: 10em; overflow: auto;"></div>
                <div class="text-right">
                  <b-btn class="mt-3 btn button-edit" @click="editData('communication', child)">{{$t('EDIT')}}</b-btn>
                </div>
              </b-tab>
              <b-tab :title="$t('INSTRUMENTFORM')">
                <div class="d-block" v-html="child.instrument" style="max-height: 10em; overflow: auto;"></div>
                <div class="text-right">
                  <b-btn class="mt-3 btn button-edit" @click="editData('instrument', child)">{{$t('EDIT')}}</b-btn>
                </div>
              </b-tab>
              <b-tab :title="$t('OPINIONFORM')">
                <div class="d-block" v-html="child.opinion" justified style="max-height: 10em; overflow: auto;"></div>
                <div class="text-right">
                  <b-btn class="mt-3 btn button-edit" @click="editData('opinion', child)">{{$t('EDIT')}}</b-btn>
                </div>
              </b-tab>
              <b-tab :title="$t('DIAGNOSEFORM')">
                <div class="d-block" v-html="child.diagnoseName" justified style="max-height: 10em; overflow: auto;"></div>
                <div class="text-right">
                  <b-btn class="mt-3 btn button-edit" @click="editData('diagnose', child)">{{$t('EDIT')}}</b-btn>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-tabs>
                <arrivalrecordwin v-bind:childId="$route.params.childId"></arrivalrecordwin>
                <TalksRecordWin v-bind:childId="$route.params.childId"></TalksRecordWin>
                <DocumentWin v-bind:childId="$route.params.childId" v-bind:type="'normal'" v-bind:title="$t('DOCUMENTWIN')"></DocumentWin>
                <DocumentWin v-bind:childId="$route.params.childId" v-bind:type="'agree'" v-bind:title="$t('AGREEDOCUMENTWIN')"></DocumentWin>
                <workplannerwin v-bind:childId="$route.params.childId"></workplannerwin>
                <ChildHistoryWin v-bind:childId="$route.params.childId"></ChildHistoryWin>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <!-- CHILD FORM -->
    <b-modal ref="formmodal" :title="$t('CHILDFORM')" ok-title="submit" hide-footer size="xl" no-close-on-backdrop>
      <div class="d-block">
        <childform v-bind:formData="formData" v-bind:formError="formError"></childform>
      </div>
      <div class="text-right">
        <b-btn class="btn button-cancel mr-2" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="btn button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
    <!-- CHILD DETAILS FORM -->
    <b-modal ref="formdetailmodal" :title="$t('CHILDDETAILSFORM')" ok-title="submit" hide-footer size="xl" no-close-on-backdrop>
      <div class="d-block">
        <childdetailsform v-bind:formData="formData" v-bind:formError="formError"></childdetailsform>
      </div>
      <div class="text-right">
        <b-btn class="btn button-cancel mr-2" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="btn button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
    <!-- PARENT FORM -->
    <b-modal ref="formparentmodal" :title="$t('CHILDDETAILSFORM')" ok-title="submit" hide-footer size="xl" no-close-on-backdrop>
      <div class="d-block">
        <parentform v-bind:formData="parent" v-bind:formError="formError"></parentform>
      </div>
      <div class="text-right">
        <b-btn class="btn button-cancel mr-2" @click="hideModalParent()">{{$t('CANCEL')}}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import Api from '@/api/child/Child';
import WalletApi from '@/api/wallet/Wallet';
import ParentsApi from '@/api/parents/Parents';
import ChildForm from './Form.vue';
import ChildDetailsForm from './FormDetail.vue';
import ParentForm from './ParentForm.vue';
import DocumentWin from './documents/DocumentsWin.vue';
import ArrivalRecordWin from './arrivalrecord/ArrivalRecordWin.vue';
import ChildHistoryWin from './WinChildHistory.vue';
import TalksRecordWin from './talksrecord/TalksRecordWin.vue';
import WorkPlannerWin from './workplanner/WorkPlannerWin.vue';
export default
{
    name: 'TherapyType',
    components:
  {
      childform: ChildForm,
      childdetailsform: ChildDetailsForm,
      arrivalrecordwin: ArrivalRecordWin,
      workplannerwin: WorkPlannerWin,
      DocumentWin,
      parentform: ParentForm,
      TalksRecordWin,
      ChildHistoryWin
  },
    data()
    {
        return {
            child: {},
            wallet: {},
            formError:
      {},
            walletFormData: null,
            formData:
      {
          name: '',
          surname: '',
          birthDate: null,
          parentId: null,
          isKindergarten: 0,
          kindergartenName: '',
          note: '',
          anamnestic: '',
          communication: '',
          instrument: '',
          opinion: '',
          diagnoseId: null,
      },
            parent: {},
        };
    },
    created()
    {
        const me = this;
        me.getWalletData();
        me.getData();
    },
    methods:
  {
      openChildData(child)
      {
        const me = this;
          me.$router.push(
              {
                  path: `/children/child/childdetails/${child.childId}`,
              },
          );
      },
      async getData()
      {
          const me = this;
          try
          {
              const data = await Api.selectSingleRow({ childId: me.$route.params.childId });
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.child = data.root;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async getWalletData()
      {
          const me = this;
          try
          {
              const data = await WalletApi.selectCurrentAmount({ childId: me.$route.params.childId });
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  return;
              }

              me.wallet = data.root;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      showModal(item)
      {
          const me = this;
          if (typeof item !== 'undefined')
          {
              me.formData = item;
          }
          this.$refs.formmodal.show();
      },
      async submitData(item)
      {
          const me = this;
          try
          {
              if (typeof item.childId !== 'undefined')
              {
                  item.id = item.childId;
                  delete (item.childId);
                  delete (item.key);
              }

              if (item.parents != null)
              {
                  delete (item.parents);
              }

              if (item.birthDate !== undefined)
              {
                  item.birthDate = moment(item.birthDate).format('YYYY-MM-DD');
              }

              const data = await Api.submitData(item);
              if (data.error)
              {
                  me.$notify.notice(data);
                  me.formError = data;
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideModal();
                  await me.getData();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideModal()
      {
          const me = this;
          this.$refs.formmodal.hide();
          this.$refs.formdetailmodal.hide();

          me.formData = {
              name: '',
              surname: '',
              parentId: null,
              isKindergarten: 0,
              kindergartenName: '',
              note: '',
              anamnestic: '',
              communication: '',
              instrument: '',
              opinion: '',
          };
      },
      editData(key, value)
      {
          const me = this;
          me.formData = value;
          me.$set(me.formData, 'key', key);
          me.$refs.formdetailmodal.show();
      },
      async showResultAndOpinion()
      {
          const me = this;
          try
          {
              await Api.printToPdf({ childId: me.$route.params.childId });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async editParentData(item)
      {
          const me = this;
          try
          {
              const data = await ParentsApi.selectRowById({ id: item.parentId });
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.parent = data.root;
              me.$refs.formparentmodal.show();
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      hideModalParent()
      {
          const me = this;
          me.$refs.formparentmodal.hide();
      },
      showWalletModal() {
        const me = this;
        me.walletFormData = { childId: me.$route.params.childId };
      },
  },
    watch:
  {

  },
    computed:
  {

  },
};
</script>
